module.exports = __webpack_public_path__ + "img/hero-xs-2x.ec3c06d.webp";